var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('el-dialog', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: _vm.getIsDialogLoading,
      expression: "getIsDialogLoading"
    }],
    staticClass: "cloneApplicationDialog",
    attrs: {
      "visible": _vm.dialogOpened,
      "width": "460px",
      "close-on-click-modal": false,
      "close-on-press-escape": false,
      "destroy-on-close": "",
      "modalAppendToBody": false,
      "show-close": false,
      "data-selector": "clone-modal"
    },
    on: {
      "update:visible": function ($event) {
        _vm.dialogOpened = $event;
      }
    },
    scopedSlots: _vm._u([{
      key: "footer",
      fn: function () {
        return [_c('el-button', {
          attrs: {
            "type": "text",
            "data-selector": "clone-m-cancel-btn"
          },
          on: {
            "click": _vm.closeDialog
          }
        }, [_vm._v(_vm._s(_vm.LABEL_CANCEL))]), _vm._v(" "), _c('el-button', {
          staticStyle: {
            "padding": "6.5px 12px"
          },
          attrs: {
            "type": "primary",
            "data-selector": "clone-m-yes-btn"
          },
          on: {
            "click": _vm.cloneApplication
          }
        }, [_vm._v(_vm._s(_vm.LABEL_YES_PROCEED))])];
      },
      proxy: true
    }])
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c('img', {
    attrs: {
      "src": require("@/assets/icons/warning-employement.svg")
    }
  }), _vm._v(" "), _c('h3', {
    staticClass: "title text-sm mt-2 text-black",
    attrs: {
      "data-selector": "cm-title"
    }
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('p', {
    staticClass: "description text-sm mt-4",
    attrs: {
      "data-selector": "cm-subtitle"
    }
  }, [_vm._v(_vm._s(_vm.subtitle))])])]);
}
var staticRenderFns = []

export { render, staticRenderFns }